import React, {Component} from "react";
import PropTypes from "prop-types";
import {DragDropContext} from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import ImmutablePropTypes from "react-immutable-proptypes";

import {Destination} from "v2/api/Records";
import DraggableDestination from "v2/components/dnd/DraggableDestination";

class ReorderDestinations extends Component {  // eslint-disable-line react/prefer-stateless-function
  static propTypes = {
    data: ImmutablePropTypes.listOf(Destination).isRequired,
    onBeginDrag: PropTypes.func.isRequired,
    onEndDrag: PropTypes.func.isRequired,
    onMove: PropTypes.func.isRequired,
    timesLoading: PropTypes.bool.isRequired,
  }

  render() {
    const {
      data,
      onBeginDrag,
      onEndDrag,
      onMove,
      timesLoading,
    } = this.props;
    return (
      <div>
        {data.map(item => (
          <DraggableDestination
            data={item}
            key={`destination-${item.id}`}
            onBeginDrag={onBeginDrag}
            onEndDrag={onEndDrag}
            onMove={onMove}
            timesLoading={timesLoading} />
        ))}
      </div>
    );
  }
}

export default DragDropContext(HTML5Backend)(ReorderDestinations);



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/dnd/ReorderDestinations.js
 **/